import React, { useState, useEffect } from 'react'
import { Col } from 'react-bootstrap'
import Chart from 'react-apexcharts'
import { gql, useQuery } from '@apollo/client'
import Card from '../common/Card'
import { useChart } from '../../utils/chart-hook'
import { CubeLoader } from '../../layouts/components/CubeLoader'

const GET_SENTIMENT = gql`
    query Campaigns {
        campaigns {
            sentiment
        }
    }
`

const SentimentAnalysisPieChart = ({ name }) => {
    const campaign = useQuery(GET_SENTIMENT)
    const [series, setSeries] = useState([])

    const { options } = useChart('donut', campaign?.data?.campaigns?.[0]?.sentiment, [
        'positive',
        'neutral',
        'negative',
    ])

    options.colors = ['#41D8B3', '#2C55DB', '#DC402D']
    options.labels = ['Positive', 'Neutral', 'Negative']

    useEffect(() => {
        if (campaign?.data?.campaigns) {
            if (campaign.data.campaigns[0]?.sentiment) {
                setSeries(campaign.data.campaigns[0]?.sentiment)
            }
        }
    }, [campaign])

    return (
        <Col md={12} xl={5}>
            {campaign.loading ? (
                <CubeLoader size="sm" fullScreen={false} />
            ) : (
                <Card data-aos="fade-up" data-aos-delay="1000">
                    <div className="flex-wrap card-header d-flex justify-content-between">
                        <div className="header-title">
                            <h6 className="card-title">{name}</h6>
                        </div>
                    </div>
                    <Card.Body>
                        <Chart className="d-activity" options={options} series={series} type="donut" height="300" />
                    </Card.Body>
                </Card>
            )}
        </Col>
    )
}

export default SentimentAnalysisPieChart
